import { createFileRoute } from '@tanstack/react-router';
import { RolesPage } from '@/features/members/pages/roles-page';

export const Route = createFileRoute('/_app/settings/roles')({ component: RolesPage });
